'use client';

import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import { FC, PropsWithChildren } from 'react';

import { RouterProvider as ArkRouterProvider } from '@sola/ark-core/contexts/router.tsx';
import { TooltipProvider } from '@sola/ark-core/molecules/tooltip/tooltip.js';
import { AuthProvider } from '@sola/auth-sdk/components/auth-provider.js';
import { Sites, getPublicConfig } from '@sola/config/lib/getters.js';
import { SiteConfigResponseDto } from '@sola/schema/lib/contentful.js';

import { SiteConfigContext } from './context';

// @TODO: Is this the same as <ArkProvider>?
export const SkippyProviders: FC<
  PropsWithChildren<{
    siteConfig?: SiteConfigResponseDto;
  }>
> = ({ children, siteConfig }) => {
  const router = useRouter();
  const publicConfig = getPublicConfig();
  const includeAuthProvider =
    publicConfig.NEXT_PUBLIC_SITE_ID !== Sites.enum.compex;

  const routerData = {
    router,
    RouterComponent: Link,
    usePathname,
  };

  const content = (
    <ArkRouterProvider routerData={routerData}>
      <SiteConfigContext.Provider value={siteConfig}>
        <TooltipProvider>{children}</TooltipProvider>
      </SiteConfigContext.Provider>
    </ArkRouterProvider>
  );

  return includeAuthProvider ? <AuthProvider>{content}</AuthProvider> : content;
};
